import {API} from "@/utils/http";
import { toast } from "@/components/ui/toast/use-toast";

export const fetchAccounts = async ({commit}, payload) => {
  try {
    const orgId = payload.orgId
    const response = await API({
      method: 'GET',
      url: `/tulum/billing/accounts/${orgId}`,
    })

    // TODO: refactor
    const accounts = await Promise.all(response.data.map(async (a) => {
      const response = await API({
        method: 'GET',
        url: `/tulum/billing/accounts/${orgId}/${a.code}`,
      })
      a.transactions = response.data.transactions
      return a
    }))

    commit('SET_ACCOUNTS', accounts)
  } catch (e) {
    console.error(e)
    toast({ title: "Can't fetch accounts", variant: 'destructive' })
  }
}
